<script setup lang="ts">
import { useThemeStore } from 'shared/themes/stores/themeStore';
import lightLogo from "@/assets/TimberTec.png"
import darkLogo from "@/assets/TimberTec_dark.png"
import { computed } from 'vue';
import { useDarkMode } from 'shared/themes/composables/darkMode';
import { storeToRefs } from 'pinia';

const darkMode = useDarkMode();
const { enabled } = storeToRefs(darkMode);

const tiyardLogoPath = computed(() => {
  return enabled.value ? darkLogo : lightLogo
})

const themeStore = useThemeStore()
const logoPath =
  themeStore.currentTheme === "SILog"
    ? new URL("@/assets/DataPolarna.svg", import.meta.url).href
    : tiyardLogoPath

const altText = themeStore.currentTheme === "SILog" ? "Datapolarna Logo" : "TimberTec Logo"
</script>

<template>
  <img :class="{ logo: themeStore.currentTheme == 'SILog' }" width="350" height="100" :src="logoPath" :alt="altText" />
</template>

<style>
.logo {
  filter: brightness(0);
}

.p-dark .logo {
  filter: none;
}
</style>
